import { OrbitControls } from '@react-three/drei'
import { Perf } from 'r3f-perf'
import PhysicsA from './PhysicsA'

export default function Experience()
{
    return <>

        {/* <Perf position="top-left" /> */}

        <OrbitControls makeDefault />

        <directionalLight 
            castShadow 
            position={ [ 1, 2, 3 ] } 
            intensity={ 4.5 } 
            shadow-camera-left={-10}
            shadow-camera-right={10}
            shadow-camera-bottom={-10}
            shadow-camera-top={10}
        />
        <ambientLight intensity={ 1.5 } />

        <PhysicsA />

    </>
}